import React, { useState } from "react";
import { EmojiHeartEyesFill, EmojiSmileFill, EmojiExpressionlessFill, EmojiFrownFill, EmojiAngryFill } from 'react-bootstrap-icons';

const EmojiRating = ({handleRating, icon_color, icon_size}) => {

    return (
            <div className="_emo-rating-container">
                <button className="_emo-rating-icon" onClick={handleRating} name="rating" value="5">
                    <EmojiHeartEyesFill color={icon_color.rating_5} size={icon_size} />
                </button>
                <button className="_emo-rating-icon" onClick={handleRating} name="rating" value="4">
                    <EmojiSmileFill color={icon_color.rating_4} size={icon_size} />
                </button>
                <button className="_emo-rating-icon" onClick={handleRating} name="rating" value="3">
                    <EmojiExpressionlessFill color={icon_color.rating_3} size={icon_size} />
                </button>
                <button className="_emo-rating-icon" onClick={handleRating} name="rating" value="2">
                    <EmojiFrownFill color={icon_color.rating_2} size={icon_size} />
                </button>
                <button className="_emo-rating-icon" onClick={handleRating} name="rating" value="1">
                    <EmojiAngryFill color={icon_color.rating_1} size={icon_size} />
                </button>
            </div>        
        )
}

export default EmojiRating;